/**
 * App Light Theme
 */
import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
   palette: {
      primary: {
         main: '#e41537' 
      },
      secondary: {
         main: '#a3ffbc'
      }
   }
});

export default theme;


// WEBPACK FOOTER //
// ./src/themes/primaryTheme.js